import React from 'react'
import obs from './../../Photo/obs.png'
import './BMI.css'
import {useLocation} from 'react-router-dom';
import { useNavigate } from "react-router-dom";

const Obs = () => {
    const location = useLocation();
    const navigate=useNavigate();
  

    const nav=()=>{
      navigate("/bmi")
    }


  return (
    <div className='appp'>
    <div className='containerr'>
    
    <img className='imgg' src={obs} alt="img not found" />
          <h3>You are obessed</h3>
          <h3>Your BMI is {(location.state.bmi).toFixed(2)}</h3>
          <button className='butn' onClick={nav} >Go Back</button> 
    </div></div>
  )
}

export default Obs;